import vue from '@/main'
import { connect } from "@/websockets/client.js"

const mutations = {


  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },
  VARIABLE_POPUP_DATA_CUSTOMER(state, val) {
    state.activeKnowPopupVariable = val
  },

  // activeInstance
  SET_ACTIVE_INSTANCE(state, name) {    
    state.activeInstance = name
  },
  
  // socketConnectionCount
  SET_SOCKET_CONNECTION_COUNT(state, name) {    
    state.socketConnectionCount = name
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    }
    else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url == payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages     = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp                 = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited    = state.starredPages.slice(0, 10)
    state.starredPages           = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val)      { state.bodyOverlay       = val },
  UPDATE_PRIMARY_COLOR(state, val)        { state.themePrimaryColor = val },
  UPDATE_THEME(state, val)                { state.theme             = val },
  UPDATE_WINDOW_WIDTH(state, width)       { state.windowWidth       = width },
  UPDATE_WINDOW_SCROLL_Y(state, val)      { state.scrollY           = val },
  UPDATE_WHATSAPP_STATUS(state, val)      { state.whatsappStatus    = val },
  UPDATE_OFFLINE_PLATFORM(state, val)     { state.offlinePlatform   = val },
  UPDATE_MAINTENANCE_STATUS(state, val)   { state.maintenanceStatus = val },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, user) {
    state.AppActiveUser = user
    localStorage.removeItem("userInfo")
    if(state.AppActiveUser.twofactor_activity && !state.AppActiveUser.is_two_factor_validated){
      user.role.has_permission_routes = [];
    }
    localStorage.setItem("userInfo", JSON.stringify(user))

    if (user.role) {
      vue.$acl.change(user.role.name)
    }
    connect()
  },

  SET_SHOW_LOADING_OVERLAY(state, showLoadingOverlay) {
    state.showLoadingOverlay = showLoadingOverlay
  },

  SET_CONNECTION_DATABASE(state, connectionDatabase){
    localStorage.setItem('connectionDatabase', connectionDatabase)
  }
}

export default mutations

